/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { styled } from '@mui/material';

export const Styles = {
  marginBottom: {
    marginBottom: '2.5rem',
    '@media (max-width: 64rem)': {
      marginBottom: '2rem',
      width: '19.5rem',
    },
  },
};

export const PunchContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '9rem',
  '@media (max-width: 64rem)': {
    gap: '2rem',
  },
}));
